import {
  ReactNode, useEffect, useMemo, useState,
} from 'react';
import { Navigate } from 'react-router-dom';
import { SnapshotContext } from '../../../utils/snapshot';
import LoadingModal from '../../loadingModal';
import { Snapshot } from '../../../types/core.type';
import { isSessionExpiredRedirectQueued } from '../../../services/adapters/baseAdapter';
import GetLatestSnapshot from '../../../services/adapters/snapshotResponse';

export default function SnapshotProvider({ children }: { children: ReactNode }) {
  const [snapshot, setSnapshot] = useState<Snapshot>({ rawSnapshot: '', formattedSnapshot: '' });
  const [loading, setLoading] = useState(true);

  const values = useMemo(() => ({ snapshot, setSnapshot }), [snapshot]);

  useEffect(() => {
    const initializeUser = async () => {
      try {
        const snapshotAdapter = new GetLatestSnapshot();
        const snapshotData = await snapshotAdapter.adaptResponse();
        setSnapshot(snapshotData);
      } catch {
        setSnapshot({ rawSnapshot: '', formattedSnapshot: '' });
      } finally {
        setLoading(false);
      }
    };

    void initializeUser();
  }, []);

  if (loading) {
    return <LoadingModal message="...loading" />;
  }

  if (!loading && snapshot.rawSnapshot === '' && snapshot.formattedSnapshot === '') {
    return isSessionExpiredRedirectQueued() ? null : <Navigate to="/login" replace />;
  }

  return (
    <SnapshotContext.Provider value={values}>{children}</SnapshotContext.Provider>
  );
}
